import { render, staticRenderFns } from "./UpdateOrCreateSplashPageComponent.vue?vue&type=template&id=3539bc79&scoped=true"
import script from "./UpdateOrCreateSplashPageComponent.vue?vue&type=script&lang=js"
export * from "./UpdateOrCreateSplashPageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3539bc79",
  null
  
)

export default component.exports